import { RiskClassification } from "../../models/consignado/risk-classifications.model";
import { axiosConsignadoInstance } from "../axiosInstance";

export type ConsignadoRiskClassificationsProps = {
  page: number;
  pageSize: number;
}
export const getRiskClassifications = async ({
  page,
  pageSize,
}: ConsignadoRiskClassificationsProps): Promise<RiskClassification[]> => {
  try {
    const response = await axiosConsignadoInstance.get<RiskClassification[]>(`/api-consignado-trabalhador/v1/risk-classifications`, {
      params: {
        pagina: page,
        tamanhoPagina: pageSize,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
};